<div class="organization-modal modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">{{ headerName }}</div>
    </h2>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>
  <div class="modal-body body-modal">
    <form [formGroup]="ssoGroupForm" id="frmProjectCreate">
      <div id="ProjectCreateValidationSummary" class="field-validation-error"></div>
      <div class="row">
        <div>
          <div class="form-group required" aria-required="true">
            <div class="services-form">
              <input
                type="text"
                formControlName="azureAdGroup"
                maxlength="50"
                placeholder="Please Enter Group Id"
              />
              <label>Azure AD Group</label>
              <div
                *ngIf="
                  (submitted || ssoGroupForm.controls['azureAdGroup'].touched) &&
                  ssoGroupForm.controls['azureAdGroup'].errors
                "
              >
                <div
                  class="input-error"
                  *ngIf="ssoGroupForm.controls['azureAdGroup'].errors?.['required']"
                >
                  The groupId field is required.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row required">
        <div aria-required="true">
          <ng-select
            [clearable]="true"
            [clearOnBackspace]="false"
            #roles
            [items]="userRoles"
            [searchable]="false"
            formControlName="userRole"
            bindLabel="roleName"
            placeholder="User Role *"
            bindValue="roleId"
            (change)="selectRoleId($event)"
          >
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div>{{ item?.roleName }}</div>
            </ng-template>
            <ng-template ng-header-tmp>
              <div class="has-feedback">
                <input
                  type="text"
                  class="accordion-search form-control search-input"
                  id="inputValidation"
                  placeholder="Search..."
                  (input)="roles.filter($any($event.target).value)"
                />
                <span class="form-control-feedback">
                  <i class="fa fa-search icon"></i>
                </span>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div [ngOptionHighlight]="search" title="{{ item?.roleName }}">
                {{ item?.roleName }}
              </div>
            </ng-template>
          </ng-select>
          <div
            *ngIf="
              (submitted || ssoGroupForm.controls['userRole'].touched) &&
              ssoGroupForm.controls['userRole'].errors
            "
          >
            <div class="input-error" *ngIf="ssoGroupForm.controls['userRole'].errors?.['required']">
              The roleId field is required.
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer box-footer">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
    <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">Save</button>
  </div>
</div>
